import React from 'react'
import {
  Card,
  Typography,
  Box,
  CircularProgress,
  useTheme,
  CardContent,
} from '@mui/material'
import useCustomStyles from '../../hooks/CustomStylesHook'
import Colors from '../../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
    margin: 'auto',
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  progressContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 180,
    height: 180,
  },
  progressText: {
    position: 'absolute',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
  },
  value: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  subValue: {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
  },
})

const TotalFundsCard: React.FC = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const totalFunds = 500000
  const totalCustomers = 500
  const targetFunds = 1000000
  const targetCustomers = 700

  const percentage = (totalFunds / targetFunds) * 100

  return (
    <Card className={classes?.card} elevation={0}>
      <CardContent>
        <Typography
          variant='h6'
          fontWeight='bold'
          gutterBottom
          color={Colors.TEXT_COLOR_MAIN}
        >
          Total Funds
        </Typography>

        <Box className={classes?.cardContainer}>
          <Box className={classes?.infoContainer}>
            <Box className={classes?.infoItem}>
              <Typography className={classes?.label}>Total Funds</Typography>
              <Typography className={classes?.value}>
                ₹ {totalFunds.toLocaleString()}
              </Typography>
              <Typography className={classes?.subValue}>
                {totalCustomers} customers
              </Typography>
            </Box>
            <Box className={classes?.infoItem}>
              <Typography className={classes?.label}>Target</Typography>
              <Typography className={classes?.value}>
                ₹ {targetFunds.toLocaleString()}
              </Typography>
              <Typography className={classes?.subValue}>
                {targetCustomers} customers
              </Typography>
            </Box>
          </Box>
          <Box className={classes?.progressContainer}>
            <CircularProgress
              variant='determinate'
              value={100}
              size={180}
              thickness={5}
              sx={{ color: theme.palette.action.hover }}
            />
            <CircularProgress
              variant='determinate'
              value={percentage}
              size={180}
              thickness={5}
              sx={{ position: 'absolute', color: theme.palette.primary.main }}
            />
            <Typography className={classes?.progressText}>
              {Math.round(percentage)}%
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default TotalFundsCard
